module.exports = __webpack_public_path__ + "static/sjopenna_2k-bfc55363a6f25c035e84da1e4cb3224e.webp";